// TODO: In prod, resources would be fetched from the database.

export const resourcesAvailable = [
    {
        name: "Perceived Lack of Control 1",
        description: "Stress and perception of control.",
        type: "article",
        link: "https://www.google.com",
        checked: false,
        stressor: "loss_of_control",
      },
      {
        name: "Work-Life Balance 1",
        description: "Stress and burnout: How to manage mental health in sales.",
        type: "article",
        link: "https://www.google.com",
        checked: false,
        stressor: "work_life_balance",
      }
]

export const recommendResource = (stressor: string) => {
    return resourcesAvailable.filter((resource) => resource.stressor === stressor);
}